import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {ThemeService, UiButtonComponent, UiInlineSvgComponent} from 'freyr-ui';
import {AuthService} from '../../core/services/auth.service';
import {ApiService} from '../../services/api.service';
import {setStoredLang} from '../../app.component';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-top-nav',
    imports: [CommonModule, RouterModule, TranslateModule, UiInlineSvgComponent, UiButtonComponent],
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent {
  readonly adminAppUrl = environment.adminAppUrl;
  userDropdownOpen = false;
  langDropdownOpen = false;

  get isDashboardRoute(): boolean {
    return this.router.url.startsWith('/dashboard');
  }

  @ViewChild('userWrap') userWrapRef?: ElementRef<HTMLElement>;
  @ViewChild('langWrap') langWrapRef?: ElementRef<HTMLElement>;

  /** Chemin du drapeau de la langue courante (image SVG pour affichage correct partout) */
  get currentLangFlagSrc(): string {
    return this.translate.currentLang === 'fr' ? 'assets/flags/fr.svg' : 'assets/flags/gb.svg';
  }

  /** Liste des langues : image drapeau + nom dans la langue (pour le dropdown) */
  readonly languages: { code: string; flagSrc: string; labelKey: string }[] = [
    { code: 'fr', flagSrc: 'assets/flags/fr.svg', labelKey: 'nav.languages.fr' },
    { code: 'en', flagSrc: 'assets/flags/gb.svg', labelKey: 'nav.languages.en' }
  ];

  constructor(
    public themeService: ThemeService,
    public translate: TranslateService,
    public authService: AuthService,
    private api: ApiService,
    private router: Router
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node;
    if (this.userWrapRef?.nativeElement?.contains(target) === false) {
      this.userDropdownOpen = false;
    }
    if (this.langWrapRef?.nativeElement?.contains(target) === false) {
      this.langDropdownOpen = false;
    }
  }

  toggleUserDropdown(): void {
    this.userDropdownOpen = !this.userDropdownOpen;
    if (this.userDropdownOpen) {
      this.langDropdownOpen = false;
    }
  }

  toggleLangDropdown(): void {
    this.langDropdownOpen = !this.langDropdownOpen;
    if (this.langDropdownOpen) {
      this.userDropdownOpen = false;
    }
  }

  closeUserDropdown(): void {
    this.userDropdownOpen = false;
  }

  get canAccessAdmin(): boolean {
    return !!this.authService.user?.roles?.includes('ADMIN');
  }

  selectLang(lang: string): void {
    this.translate.use(lang);
    setStoredLang(lang);
    this.langDropdownOpen = false;
  }

  goToLogin(): void {
    this.api.getTwitchLoginUrl().subscribe({
      next: (response) => {
        if (response?.url) {
          window.location.href = response.url;
        }
      },
      error: () => {}
    });
  }

  logout(): void {
    // fetch avec redirect: 'manual' pour recevoir la 302 + Set-Cookie (vide) sans suivre la redirection,
    // afin que le navigateur applique bien la suppression du cookie avant qu’on vide l’état et qu’on redirige.
    fetch(this.api.getLogoutUrl(), { credentials: 'include', redirect: 'manual' })
      .then(() => this.clearAuthAndRedirect())
      .catch(() => this.clearAuthAndRedirect());
  }

  private clearAuthAndRedirect(): void {
    this.authService.clearUser();
    window.location.href = window.location.origin + '/';
  }

  goToAdmin(): void {
    this.closeUserDropdown();
    window.location.href = this.adminAppUrl;
  }
}





